<template>
  <el-dialog
    :visible="true"
    title="默认图片编辑"
    width="80%"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <el-radio-group v-model="imgIndex" size="small">
      <el-radio
        v-for="(item, index) in imgList"
        :key="index"
        :label="index"
        style="margin-bottom:10px;"
      >
        <img class="radio-img" :src="item" alt="" />
      </el-radio>
    </el-radio-group>
    <canvas
      @mousemove="mousemove"
      @mousedown="mousedown"
      @mouseup="mouseup"
      ref="canvas"
      id="myCanvas"
      width="700"
      height="200"
    ></canvas>
    <!-- <el-form ref="ruleForm" class="ruleForm">
      <el-form-item label="文字内容：">
        <el-input v-model="name" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="文字颜色：" style="margin-top:10px">
        <el-input v-model="color" placeholder="请输入RGB颜色值如rgb(255,182,193)或十六进制颜色码如#FFB6C1"></el-input>
      </el-form-item>
      <el-form-item label="文字大小：" style="margin-top:10px">
        <el-input v-model="fontSize" placeholder="文字大小 单位PX"></el-input>
      </el-form-item>
      <el-form-item style="margin-top:10px">
        <el-button type="primary" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>-->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="close">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      imgIndex: 0,
      imgList: [],
      name: '',
      color: '#fff',
      ctx: '', // canvas
      moveFlag: false, // 是否可以移动表示  true 标识按下
      textX: 150, // 文字 X轴
      textY: 100, // 文字 Y轴
      imgW: 686, // drawImage 宽
      imgH: 196,
      fontSize: 20, // 文字大小 PX 也是高度
      fontWidth: 0 // 文本宽度
    };
  },
  components: {},
  watch: {
    imgIndex: {
      immediate: true,
      handler(v) {
        this.$nextTick(() => {
          if (!this.ctx) {
            this.ctx = this.$refs.canvas.getContext('2d');
          }
          this.selectRadio(v);
        });
      }
    },
    name() {
      this.selectRadio(this.imgIndex);
    },
    color() {
      this.selectRadio(this.imgIndex);
    },
    fontSize() {
      this.selectRadio(this.imgIndex);
    }
  },
  computed: {},
  methods: {
    fileDownload(downloadUrl) {
      let aLink = document.createElement('a');
      aLink.style.display = 'none';
      aLink.href = downloadUrl;
      aLink.download = '封面.png';
      // 触发点击-然后移除
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    },
    // DataURL转Blob对象
    dataURLToBlob(dataurl) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    selectRadio(index) {
      let img = new Image();
      img.crossOrigin = '*'; //可选值：anonymous，*
      img.src = this.imgList[index];
      img.onload = () => {
        this.ctx.drawImage(img, 0, 0, this.imgW, this.imgH);
        this.ctx.font = `${this.fontSize}px '微软雅黑'`;
        this.ctx.fillStyle = this.color;
        this.ctx.fillText(this.name, this.textX, this.textY);
        this.fontWidth = this.ctx.measureText(this.name).width;
      };
      // this.imgSrc = srccc;
    },
    confirm() {
      // let srccc = this.$refs.canvas.toDataURL("image/png", 1);
      // 转成个下载流格式
      // this.fileDownload(srccc.replace("image/png", "image/octet-stream"));

      this.$refs.canvas.toBlob(blob => {
        // this.$refs.uploader.handleStart(blob);
        // this.$refs.uploader.submit();
        this.$emit('dialog-confirm', blob);
      }, 'image/png');

      // this.$refs.uploader.handleStart(this.dataURLToBlob(srccc));
      // this.$refs.uploader.submit();
    },
    close() {
      this.$emit('dialog-close', true);
    },
    textChange() {},
    mousemove(e) {
      if (this.moveFlag) {
        let { offsetX, offsetY } = e;
        this.textX = offsetX;
        this.textY = offsetY;
        // 最左
        if (offsetX < 1) {
          this.textX = 1;
        }
        // 最右
        if (offsetX > this.imgW - this.fontWidth) {
          this.textX = this.imgW - this.fontWidth;
        }
        // 最上
        if (offsetY < this.fontSize) {
          this.textY = this.fontSize;
        }
        // 最下
        if (offsetY > this.imgH - 3) {
          this.textY = this.imgH - 3;
        }
        // 超出边界
        if (
          offsetX < 2 ||
          offsetX > this.imgW - 3 ||
          offsetY < 2 ||
          offsetY > this.imgH - 3
        ) {
          this.moveFlag = false;
        }
        this.selectRadio(this.imgIndex);
      }
    },
    mousedown(e) {
      let { offsetX, offsetY } = e;
      // 点击目标
      if (
        offsetX - this.textX > 0 &&
        this.textX + this.fontWidth - offsetX > 0 &&
        offsetY - this.textY > -this.fontSize &&
        offsetY - this.textY < 0
      ) {
        this.moveFlag = true;
      }
    },
    mouseup() {
      this.moveFlag = false;
    },
    rest() {
      this.textX = 150;
      this.textY = 100;
      this.color = '#fff';
      this.selectRadio(this.imgIndex);
    }
  },
  created() {
    // this.name = getStorage("user").userName;
  },
  mounted() {
    for (let i = 1; i < 17; i++) {
      this.imgList.push(`http://cdn.yxvzb.com/WEB/sass/B/img/${i}.png`);
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
.radio-img {
  width: 70px;
  height: 20px;
}
#myCanvas {
  // transform: scale(0.5);
  // display: none;
  display: block;
  margin: auto;
  margin-top: 30px;
}
</style>
